export enum PresentationStyle {
  Default = 'default',
  Modal = 'modal',
  KitModal = 'kitModal', // supported in release 5.21+
}

export enum NativeTopBarStyle {
  Default = 'default',
  Hidden = 'hidden',
  Transparent = 'transparent',
  TransparentOnDark = 'transparentOnDark',
  TransparentOnLight = 'transparentOnLight',
  Light = 'light',
  Dark = 'dark',
}
